import { memo, useState } from 'react';

import { cn } from '@air/utils-tailwind';

import { type RenderOutlinePageMenu } from './PDFViewerOutlinePage';

type PDFViewerOutlinePageMenuProps = {
  pageNumber: number;
  renderOutlinePageMenu: RenderOutlinePageMenu;
};

export const PDFViewerOutlinePageMenu = memo(({ pageNumber, renderOutlinePageMenu }: PDFViewerOutlinePageMenuProps) => {
  const [isMenuOpen, setMenuIsOpen] = useState(false);

  return (
    <div
      className={cn(
        'absolute top-2 right-2 hidden group-focus-within/outline-page:flex group-hover/outline-page:flex group-active/outline-page:flex',
        isMenuOpen ? 'flex' : '',
      )}
    >
      {renderOutlinePageMenu({ pageNumber, setMenuIsOpen })}
    </div>
  );
});

PDFViewerOutlinePageMenu.displayName = 'PDFViewerOutlinePageMenu';
